var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMapMarkerF = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#55b648",
    d: "M7 20.565q-7-9.135-7-13a7 7 0 0 1 14 0q0 3.865-7 13zm0-9a4 4 0 1 0-4-4 4 4 0 0 0 4 4z",
    transform: "translate(0 -.565)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMapMarkerF);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map-marker-f.6690f40335f7a9008ae0a0841fa1ef17.svg";